import { RestuxFilters } from '../../../store/restux/restux.model'
import { DocumentCategoryKeys, DocumentCategory } from '../../../model/DocumentCategory'
import { TagType } from '../../../model/Tag'
import { ReactNode } from 'react'
import { TestProps } from '../../../misc/types.utilities'
import { SelectOption } from '../../../model/SelectOption'

export enum FiltersType {
  DocumentCategory = 'DocumentCategory',
  Title = 'Title',
  Visibility = 'Visibility',
  Tags = 'Tags',
}

export interface SearchPanelFilters {
  search: string
  documentCategories: ReadonlyArray<DocumentCategoryKeys>
  tagIds: ReadonlyArray<string>
  visibility?: SelectOption<string>
}

export interface FiltersProps extends TestProps {
  tags: ReadonlyArray<TagType>
  capabilities: ReadonlyArray<FiltersType>
  usedTags?: ReadonlyArray<TagType>
  documentCategories?: ReadonlyArray<DocumentCategory>
  hideActionItems?: boolean
  customVisibilityOptions?: SelectOption<string>[]
  onFiltersChange: (filters: RestuxFilters) => void
  resetPagination: () => void
  onClearFilters?: () => void
  renderActionItem?: () => ReactNode
  renderCustomFilters?: (resetPagination: () => void) => ReactNode
}
